import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/MedicalImaging/Hero/Hero";
//--------------------------------------------
import Serv from '../../components/Serv' ;
import Frame from '../../components/Frame';
import UpButton from '../../components/UpButton';
//============================================
import { Helmet } from "react-helmet";
const ProductsHealthcare = ({scroll}) => {
  return (
    <div>
      <Helmet>
        <title>Millensys - Products</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero Healthcare={true}/>
        <Serv Healthcare={true}/>
        <Frame/>
        <Footer />
      </div>
    </div>
  );
};

export default ProductsHealthcare;
